// Load SCSS only — all JS is loaded via script tags in index.webpack.html
require('../stylesheets/application.css.scss');
